<template>
  <el-dialog :title="$t('editGold.edit')" :visible.sync="dialogVisible" width="60%" :before-close="handleClose">
    <div class="dialog-card">
      <el-form :model="editGoldInfo" label-width="120px">
        <el-form-item :label="$t('editGold.name')">
          <el-input v-model="editGoldInfo.goldName" :placeholder="$t('editGold.namePlaceholder')" disabled></el-input>
        </el-form-item>
        <el-form-item :label="$t('editGold.amount')">
          <el-input v-model="editGoldInfo.amount" :placeholder="$t('editGold.amountPlaceholder')"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editGold">{{ $t('common.save') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateGold } from '@/api/admin/gold/goldApi'

export default {
  name: 'EditGold',
  data() {
    return {
      dialogVisible: false,
      editGoldInfo: {
        goldId: '',
        goldName: '',
        amount: '',
        goldType: '',
        objId: '',
        link: ''
      }
    }
  },
  methods: {
    open(gold) {
      this.resetForm()
      Object.assign(this.editGoldInfo, gold)
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    resetForm() {
      this.editGoldInfo = {
        goldId: '',
        goldName: '',
        amount: '',
        goldType: '',
        objId: '',
        link: ''
      }
    },
    editGold() {
      if (!this.validate()) {
        return
      }

      updateGold(this.editGoldInfo)
        .then(response => {
          console.log(response)
          this.$message.success(this.$t('editGold.updateSuccess'))
          this.$emit('refresh')
          this.handleClose()
        })
        .catch(error => {
          this.$message.error(error.message || this.$t('editGold.updateFailed'))
        })
    },
    validate() {
      if (!this.editGoldInfo.amount) {
        this.$message.error(this.$t('editGold.amountRequired'))
        return false
      }
      if (this.editGoldInfo.amount.length > 10) {
        this.$message.error(this.$t('editGold.amountMaxLength'))
        return false
      }
      if (!this.editGoldInfo.goldId) {
        this.$message.error(this.$t('editGold.idRequired'))
        return false
      }
      return true
    }
  }
}
</script>

<style scoped>
.dialog-card {
  margin: -20px;
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
}

/* 表单样式优化 */
.el-form-item {
  margin-bottom: 20px;
}

.el-form-item:last-child {
  margin-bottom: 0;
}

/* 输入框样式 */
.el-input {
  width: 100%;
}

/* 响应式布局 */
@media (max-width: 768px) {
  .dialog-card {
    padding: 15px;
  }
  
  .el-form-item {
    margin-bottom: 15px;
  }
}
</style>